// Ethereum 1
// > BSC 97
// > Avalanche 43114
// > Polygon 137
// > Arbitrum 42161
// > Fantom 250
// > Metis
// > Moonriver 1285
// > Celo 44787
// > Aurora 1313161554
// > Harmony
// > Optimism 10
// > Boba 288
// > OKExChain 66
// > Heco 128
// > xDai 100
const sortedChainNames = [
  "Ethereum",
  "BSC",
  "Avalanche",
  "Polygon",
  "Arbitrum",
  "Fantom",
  "Metis",
  "Oasis",
  "Celo",
  "Aurora",
  "Harmony",
  "Moonbeam",
  "Moonriver",
  "Optimism",
  "Boba",
  "OKExChain",
  "Heco",
  "xDai",
];

export { sortedChainNames };
